import { render, staticRenderFns } from "./CreatePostVenta.vue?vue&type=template&id=33c13f61&scoped=true"
import script from "./CreatePostVenta.vue?vue&type=script&lang=js"
export * from "./CreatePostVenta.vue?vue&type=script&lang=js"
import style0 from "./CreatePostVenta.vue?vue&type=style&index=0&id=33c13f61&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c13f61",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VCol,VForm,VRow,VTextField})
